export const env = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://Be.YOCAS.life:4000',
  wsUrl: import.meta.env.VITE_WS_URL || 'wss://Be.YOCAS.life:4000',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  bugsnagApiKey: import.meta.env.VITE_BUGSNAG_API_KEY || '',
};

export const STORAGE_KEYS = {
  originalUser: 'STORAGE_KEY_ORIGINAL_USER_KEY',
  hideNewBadge: 'HIDE_NEW_BADGE',
  soundOn: 'soundOn',
  userId: 'userId',
};
